<template>
  <PAGE :is-sys="true" />
</template>
<script>
import PAGE from '../hand/components/Page';
export default {
  name: 'BusinessLabelSys',
  components: { PAGE },
  data() {
    return {};
  },
};
</script>
